<button
  class="flex items-center justify-center gap-1 bg-white border-2 border-black rounded-3xl px-6 py-1 text-base w-full hover:bg-main-yellow hover:border-main-yellow transition ease-in-out hover:scale-105 duration-150 md:text-lg disabled:bg-[#D5D5D5] disabled:border-[#D5D5D5] disabled:text-[#6F6F6F] disabled:hover:scale-100"
  type="button"
  (click)="onClickButton($event)"
  [disabled]="isDisable"
>
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <span class="font-normal">{{ content | transloco }}</span>
</button>
